import * as types from './action_types';
import PointsLeaderboardService from '../../services/points_leaderboard';

export const fetch = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.POINTS_LEADERBOARD_RETRIEVING });
      const pointsLeaderboardData = await PointsLeaderboardService.fetch();
      const pointsLeaderboard = []
      for (let pointsLeaderboardDataItem of pointsLeaderboardData) {
        pointsLeaderboard.push({
          points: pointsLeaderboardDataItem.points,
          slug: pointsLeaderboardDataItem.slug,
          userName: pointsLeaderboardDataItem.user_name
        });
      }
      dispatch({ type: types.POINTS_LEADERBOARD_RETRIEVED, pointsLeaderboard });
    } catch(error) {
      dispatch({ type: types.POINTS_LEADERBOARD_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/points_leaderboard/actions.js